import {
  getVeralliaDashboardLastCompletedShiftRange,
} from '../services/dashboard/verallia-dashboard-service';

const HOUR = 3600;
const DAY = 86400;

const MOCK_NOW = Math.floor(Date.now() / 1000);
const LAST_SHIFT = getVeralliaDashboardLastCompletedShiftRange(MOCK_NOW);

const DUMMY_IMAGE_URL = 'https://placehold.co/1200x700/D8CBB8/51483D?text=Verallia+Detection';

const getLastShiftTimestamp = (ratio) => {
  return Math.floor(
    LAST_SHIFT.start + (LAST_SHIFT.end - LAST_SHIFT.start) * ratio,
  );
};

const createDetection = (
  id,
  timestamp,
  line,
  palletId,
  defect,
  size,
) => ({
  id,
  timestamp,
  line,
  palletId,
  defect,
  size,
  image: DUMMY_IMAGE_URL,
});

export const VERALLIA_DASHBOARD_MOCK_DETECTIONS = [
  // Last completed shift.
  createDetection('DET-0001', getLastShiftTimestamp(0.05), 'L2', 'PAL-260824-0001', 'broken_glass', 36.5),
  createDetection('DET-0002', getLastShiftTimestamp(0.11), 'L1', 'PAL-260824-0002', 'missing_unit', null),
  createDetection('DET-0003', getLastShiftTimestamp(0.17), 'L3', 'PAL-260824-0003', 'layer_overhang', 88.5),
  createDetection('DET-0004', getLastShiftTimestamp(0.23), 'L2', 'PAL-260824-0004', 'label_defect', null),
  createDetection('DET-0005', getLastShiftTimestamp(0.29), 'L1', 'PAL-260824-0005', 'pallet_damage', 49.0),
  createDetection('DET-0006', getLastShiftTimestamp(0.35), 'L3', 'PAL-260824-0006', 'film_defect', 22.4),
  createDetection('DET-0007', getLastShiftTimestamp(0.41), 'L1', 'PAL-260824-0007', 'stack_deformation', null),
  createDetection('DET-0008', getLastShiftTimestamp(0.47), 'L2', 'PAL-260824-0008', 'broken_glass', 73.0),
  createDetection('DET-0009', getLastShiftTimestamp(0.53), 'L3', 'PAL-260824-0009', 'pallet_damage', 53.5),
  createDetection('DET-0010', getLastShiftTimestamp(0.59), 'L1', 'PAL-260824-0010', 'label_defect', 12.1),
  createDetection('DET-0011', getLastShiftTimestamp(0.65), 'L3', 'PAL-260824-0011', 'layer_overhang', 11.5),
  createDetection('DET-0012', getLastShiftTimestamp(0.71), 'L2', 'PAL-260824-0012', 'film_defect', 31.8),
  createDetection('DET-0013', getLastShiftTimestamp(0.77), 'L1', 'PAL-260824-0013', 'broken_glass', 87.0),
  createDetection('DET-0014', getLastShiftTimestamp(0.83), 'L3', 'PAL-260824-0014', 'missing_unit', null),
  createDetection('DET-0015', getLastShiftTimestamp(0.89), 'L1', 'PAL-260824-0015', 'pallet_damage', 46.5),
  createDetection('DET-0016', getLastShiftTimestamp(0.95), 'L2', 'PAL-260824-0016', 'stack_deformation', null),

  // Recent detections.
  createDetection('DET-0017', MOCK_NOW - 30 * 60, 'L1', 'PAL-260824-0017', 'broken_glass', 24.8),
  createDetection('DET-0018', MOCK_NOW - 75 * 60, 'L2', 'PAL-260824-0018', 'film_defect', 18.6),
  createDetection('DET-0019', MOCK_NOW - 2 * HOUR, 'L3', 'PAL-260824-0019', 'label_defect', null),
  createDetection('DET-0020', MOCK_NOW - 3 * HOUR, 'L1', 'PAL-260824-0020', 'missing_unit', null),
  createDetection('DET-0021', MOCK_NOW - 4 * HOUR, 'L2', 'PAL-260824-0021', 'layer_overhang', 61.2),
  createDetection('DET-0022', MOCK_NOW - 5 * HOUR, 'L3', 'PAL-260824-0022', 'pallet_damage', 39.1),
  createDetection('DET-0023', MOCK_NOW - 9 * HOUR, 'L1', 'PAL-260824-0023', 'stack_deformation', null),
  createDetection('DET-0024', MOCK_NOW - 11 * HOUR, 'L2', 'PAL-260824-0024', 'broken_glass', 43.7),
  createDetection('DET-0025', MOCK_NOW - 13 * HOUR, 'L3', 'PAL-260824-0025', 'film_defect', 28.2),
  createDetection('DET-0026', MOCK_NOW - 15 * HOUR, 'L1', 'PAL-260824-0026', 'label_defect', 9.8),
  createDetection('DET-0027', MOCK_NOW - 18 * HOUR, 'L2', 'PAL-260824-0027', 'missing_unit', null),
  createDetection('DET-0028', MOCK_NOW - 20 * HOUR, 'L3', 'PAL-260824-0028', 'pallet_damage', 51.4),
  createDetection('DET-0029', MOCK_NOW - 22 * HOUR, 'L1', 'PAL-260824-0029', 'layer_overhang', 77.3),
  createDetection('DET-0030', MOCK_NOW - 23 * HOUR, 'L2', 'PAL-260824-0030', 'broken_glass', 34.9),

  // Last 30 days.
  createDetection('DET-0031', MOCK_NOW - 2 * DAY - 2 * HOUR, 'L3', 'PAL-260822-0031', 'film_defect', 21.7),
  createDetection('DET-0032', MOCK_NOW - 3 * DAY - 8 * HOUR, 'L1', 'PAL-260821-0032', 'pallet_damage', 42.8),
  createDetection('DET-0033', MOCK_NOW - 4 * DAY - 13 * HOUR, 'L2', 'PAL-260820-0033', 'missing_unit', null),
  createDetection('DET-0034', MOCK_NOW - 5 * DAY - 5 * HOUR, 'L3', 'PAL-260819-0034', 'label_defect', null),
  createDetection('DET-0035', MOCK_NOW - 6 * DAY - 11 * HOUR, 'L1', 'PAL-260818-0035', 'broken_glass', 67.5),
  createDetection('DET-0036', MOCK_NOW - 7 * DAY - 17 * HOUR, 'L2', 'PAL-260817-0036', 'layer_overhang', 58.0),
  createDetection('DET-0037', MOCK_NOW - 8 * DAY - 3 * HOUR, 'L3', 'PAL-260816-0037', 'stack_deformation', null),
  createDetection('DET-0038', MOCK_NOW - 9 * DAY - 14 * HOUR, 'L1', 'PAL-260815-0038', 'film_defect', 16.4),
  createDetection('DET-0039', MOCK_NOW - 10 * DAY - 7 * HOUR, 'L2', 'PAL-260814-0039', 'pallet_damage', 72.6),
  createDetection('DET-0040', MOCK_NOW - 11 * DAY - 19 * HOUR, 'L3', 'PAL-260813-0040', 'broken_glass', 31.2),
  createDetection('DET-0041', MOCK_NOW - 12 * DAY - 6 * HOUR, 'L1', 'PAL-260812-0041', 'label_defect', 8.5),
  createDetection('DET-0042', MOCK_NOW - 13 * DAY - 10 * HOUR, 'L2', 'PAL-260811-0042', 'missing_unit', null),
  createDetection('DET-0043', MOCK_NOW - 14 * DAY - 15 * HOUR, 'L3', 'PAL-260810-0043', 'layer_overhang', 64.2),
  createDetection('DET-0044', MOCK_NOW - 15 * DAY - 20 * HOUR, 'L1', 'PAL-260809-0044', 'stack_deformation', null),
  createDetection('DET-0045', MOCK_NOW - 16 * DAY - 4 * HOUR, 'L2', 'PAL-260808-0045', 'film_defect', 23.9),
  createDetection('DET-0046', MOCK_NOW - 17 * DAY - 12 * HOUR, 'L3', 'PAL-260807-0046', 'pallet_damage', 48.1),
  createDetection('DET-0047', MOCK_NOW - 18 * DAY - 18 * HOUR, 'L1', 'PAL-260806-0047', 'broken_glass', 55.4),
  createDetection('DET-0048', MOCK_NOW - 19 * DAY - 9 * HOUR, 'L2', 'PAL-260805-0048', 'label_defect', null),
  createDetection('DET-0049', MOCK_NOW - 20 * DAY - 1 * HOUR, 'L3', 'PAL-260804-0049', 'missing_unit', null),
  createDetection('DET-0050', MOCK_NOW - 21 * DAY - 14 * HOUR, 'L1', 'PAL-260803-0050', 'layer_overhang', 81.1),
  createDetection('DET-0051', MOCK_NOW - 22 * DAY - 5 * HOUR, 'L2', 'PAL-260802-0051', 'stack_deformation', null),
  createDetection('DET-0052', MOCK_NOW - 23 * DAY - 16 * HOUR, 'L3', 'PAL-260801-0052', 'film_defect', 19.3),
  createDetection('DET-0053', MOCK_NOW - 24 * DAY - 21 * HOUR, 'L1', 'PAL-260731-0053', 'pallet_damage', 60.7),
  createDetection('DET-0054', MOCK_NOW - 25 * DAY - 2 * HOUR, 'L2', 'PAL-260730-0054', 'broken_glass', 44.5),
  createDetection('DET-0055', MOCK_NOW - 26 * DAY - 8 * HOUR, 'L3', 'PAL-260729-0055', 'label_defect', 11.4),
  createDetection('DET-0056', MOCK_NOW - 27 * DAY - 13 * HOUR, 'L1', 'PAL-260728-0056', 'missing_unit', null),
  createDetection('DET-0057', MOCK_NOW - 28 * DAY - 6 * HOUR, 'L2', 'PAL-260727-0057', 'layer_overhang', 69.8),
  createDetection('DET-0058', MOCK_NOW - 29 * DAY - 11 * HOUR, 'L3', 'PAL-260726-0058', 'stack_deformation', null),
  createDetection('DET-0059', MOCK_NOW - 30 * DAY - 17 * HOUR, 'L1', 'PAL-260725-0059', 'film_defect', 26.2),
  createDetection('DET-0060', MOCK_NOW - 3 * DAY - 22 * HOUR, 'L2', 'PAL-260821-0060', 'broken_glass', 52.7),

  // Long-term history.
  createDetection('DET-0061', MOCK_NOW - 35 * DAY - 4 * HOUR, 'L3', 'PAL-0061', 'pallet_damage', 38.6),
  createDetection('DET-0062', MOCK_NOW - 40 * DAY - 9 * HOUR, 'L1', 'PAL-0062', 'missing_unit', null),
  createDetection('DET-0063', MOCK_NOW - 45 * DAY - 14 * HOUR, 'L2', 'PAL-0063', 'broken_glass', 71.3),
  createDetection('DET-0064', MOCK_NOW - 50 * DAY - 3 * HOUR, 'L3', 'PAL-0064', 'label_defect', null),
  createDetection('DET-0065', MOCK_NOW - 55 * DAY - 18 * HOUR, 'L1', 'PAL-0065', 'film_defect', 32.8),
  createDetection('DET-0066', MOCK_NOW - 60 * DAY - 7 * HOUR, 'L2', 'PAL-0066', 'layer_overhang', 56.4),
  createDetection('DET-0067', MOCK_NOW - 70 * DAY - 12 * HOUR, 'L3', 'PAL-0067', 'stack_deformation', null),
  createDetection('DET-0068', MOCK_NOW - 80 * DAY - 20 * HOUR, 'L1', 'PAL-0068', 'pallet_damage', 45.9),
  createDetection('DET-0069', MOCK_NOW - 90 * DAY - 5 * HOUR, 'L2', 'PAL-0069', 'broken_glass', 29.4),
  createDetection('DET-0070', MOCK_NOW - 100 * DAY - 15 * HOUR, 'L3', 'PAL-0070', 'missing_unit', null),
  createDetection('DET-0071', MOCK_NOW - 110 * DAY - 8 * HOUR, 'L1', 'PAL-0071', 'label_defect', 10.7),
  createDetection('DET-0072', MOCK_NOW - 120 * DAY - 17 * HOUR, 'L2', 'PAL-0072', 'film_defect', 24.1),
  createDetection('DET-0073', MOCK_NOW - 130 * DAY - 1 * HOUR, 'L3', 'PAL-0073', 'layer_overhang', 76.5),
  createDetection('DET-0074', MOCK_NOW - 140 * DAY - 11 * HOUR, 'L1', 'PAL-0074', 'stack_deformation', null),
  createDetection('DET-0075', MOCK_NOW - 150 * DAY - 19 * HOUR, 'L2', 'PAL-0075', 'pallet_damage', 62.3),
  createDetection('DET-0076', MOCK_NOW - 160 * DAY - 6 * HOUR, 'L3', 'PAL-0076', 'broken_glass', 40.8),
  createDetection('DET-0077', MOCK_NOW - 170 * DAY - 13 * HOUR, 'L1', 'PAL-0077', 'missing_unit', null),
  createDetection('DET-0078', MOCK_NOW - 180 * DAY - 22 * HOUR, 'L2', 'PAL-0078', 'label_defect', null),
  createDetection('DET-0079', MOCK_NOW - 190 * DAY - 4 * HOUR, 'L3', 'PAL-0079', 'film_defect', 17.9),
  createDetection('DET-0080', MOCK_NOW - 200 * DAY - 10 * HOUR, 'L1', 'PAL-0080', 'layer_overhang', 84.6),
  createDetection('DET-0081', MOCK_NOW - 210 * DAY - 16 * HOUR, 'L2', 'PAL-0081', 'stack_deformation', null),
  createDetection('DET-0082', MOCK_NOW - 220 * DAY - 7 * HOUR, 'L3', 'PAL-0082', 'pallet_damage', 43.2),
  createDetection('DET-0083', MOCK_NOW - 230 * DAY - 14 * HOUR, 'L1', 'PAL-0083', 'broken_glass', 65.7),
  createDetection('DET-0084', MOCK_NOW - 240 * DAY - 21 * HOUR, 'L2', 'PAL-0084', 'missing_unit', null),
  createDetection('DET-0085', MOCK_NOW - 250 * DAY - 2 * HOUR, 'L3', 'PAL-0085', 'label_defect', 13.6),
  createDetection('DET-0086', MOCK_NOW - 260 * DAY - 9 * HOUR, 'L1', 'PAL-0086', 'film_defect', 20.5),
  createDetection('DET-0087', MOCK_NOW - 270 * DAY - 18 * HOUR, 'L2', 'PAL-0087', 'layer_overhang', 59.7),
  createDetection('DET-0088', MOCK_NOW - 280 * DAY - 5 * HOUR, 'L3', 'PAL-0088', 'stack_deformation', null),
  createDetection('DET-0089', MOCK_NOW - 290 * DAY - 12 * HOUR, 'L1', 'PAL-0089', 'pallet_damage', 54.8),
  createDetection('DET-0090', MOCK_NOW - 300 * DAY - 20 * HOUR, 'L2', 'PAL-0090', 'broken_glass', 35.1),
  createDetection('DET-0091', MOCK_NOW - 310 * DAY - 6 * HOUR, 'L3', 'PAL-0091', 'missing_unit', null),
  createDetection('DET-0092', MOCK_NOW - 320 * DAY - 14 * HOUR, 'L1', 'PAL-0092', 'label_defect', null),
  createDetection('DET-0093', MOCK_NOW - 330 * DAY - 23 * HOUR, 'L2', 'PAL-0093', 'film_defect', 27.6),
  createDetection('DET-0094', MOCK_NOW - 340 * DAY - 8 * HOUR, 'L3', 'PAL-0094', 'layer_overhang', 73.4),
  createDetection('DET-0095', MOCK_NOW - 350 * DAY - 15 * HOUR, 'L1', 'PAL-0095', 'stack_deformation', null),
  createDetection('DET-0096', MOCK_NOW - 360 * DAY - 3 * HOUR, 'L2', 'PAL-0096', 'pallet_damage', 41.7),
  createDetection('DET-0097', MOCK_NOW - 115 * DAY - 13 * HOUR, 'L3', 'PAL-0097', 'broken_glass', 68.2),
  createDetection('DET-0098', MOCK_NOW - 185 * DAY - 17 * HOUR, 'L1', 'PAL-0098', 'film_defect', 30.4),
  createDetection('DET-0099', MOCK_NOW - 245 * DAY - 11 * HOUR, 'L2', 'PAL-0099', 'label_defect', 9.6),
  createDetection('DET-0100', MOCK_NOW - 305 * DAY - 7 * HOUR, 'L3', 'PAL-0100', 'layer_overhang', 79.5),
];